// extracted by mini-css-extract-plugin
export default {"iconCircle":"style_iconCircle__0+CPP","popIn":"style_popIn__9YjP3","successText":"style_successText__ZNlgc","benefits":"style_benefits__VsuFL","benefit":"style_benefit__dc0lD"};